export default {
  banner: {
    description: 'Poupe {{range}} ao encomendar através da app gratuita FoodAmigos. Clique aqui para obter a app →',
  },
  labels: {
    deals: 'Promoções',
    collecting_points: 'Já está a acumular pontos?',
    earn_points: 'Ganhe Pontos e obtenha Recompensas ',
    order_again: 'Encomendar novamente',
  },
  checkout_button: {
    title: 'Ir para o carrinho',
  },
};
